import React, { Component } from 'react';
import { Row, Col,  Form, FormGroup, Input } from 'reactstrap';
import { connect } from 'react-redux';
import ReactPaginate from 'react-paginate';
import { fetchCUGPortfolioRequest, saveCUGCorporateData , fetchCUGportfolioDataBySearch} from './action';
import { Preloading } from '../../../components/UI/Preloader/action';
import { goolgeAnalyticsEvents, setPageView } from '../../../components/GoogleAnalytics/index';
import CUGPortfolioTable from './cug-portfolio-table';
import * as PortfolioConstants from '../constants';
import {
  pageLink, currentLink
} from '../helper';
import { data } from 'autoprefixer';

const requestBody = {
  searchString: "",
  counterpartyFilter: [],
  productNameFilter: [],
  riskLevelFilter: [],
  zoneFilter: [],
  legalConstitutionFilter: [],
  businessSegmentFilter: [],
  caseStatusFilter: [],
  riskScoreTrendFilter: [],
  countryFilter: [],
  stateFilter: []
}

class CUGPortfolio extends Component {

  state = { 
    cugPortfoliioList : {} , 
    currentPage: parseInt(this.props.urlPageNumber) - 1,
    searchKeyword : undefined
  };

  componentDidMount() {
    setPageView('/Corporate/Portfolio', '/cug-portfolio');
    this.props.preloading(true);
    this.props.fetchCUGPortfolioRequest(this.state.currentPage);
  }

  componentDidUpdate(prevProps) {
    if(this.props.urlPageNumber !== prevProps.urlPageNumber && !this.state.searchKeyword ){
      this.props.fetchCUGPortfolioRequest(this.props.urlPageNumber - 1);
    }else if(this.props.urlPageNumber !== prevProps.urlPageNumber && this.state.searchKeyword  && this.state.searchKeyword.trim().length > 0){
     this.fetchSerachData();
    }
    if(prevProps.cugPortfoliioList !== this.props.cugPortfoliioList){
      this.props.preloading(false);
      this.setState({cugPortfoliioList : this.props.cugPortfoliioList });
    }
  }
  
  handleOnCLick = (p) => {
    this.props.saveCUGCorporateData(p);
    let url = `/cug-report/${p.corporateId}/${p.counterpartyId}/${p.cugId}`;
    this.props.history.push(url);
  }

  handleCugPortFolioPagination = (pageNo ) => {
    this.props.preloading(true)
    goolgeAnalyticsEvents('Corporate', 'Update CUG Portfolio Table Page Number', 'CUG Portfolio Pagination', pageNo + 1);
    this.setState({
      currentPage: pageNo
    });
    let url = `/cug-portfolio/${pageNo + 1}/${this.state.searchKeyword ? this.state.searchKeyword : ""}`
    this.props.history.push(url) 
  }

  fetchSerachData = () => {
    let body = { requestData : {...requestBody , searchString : this.state.searchKeyword }, pageNumber : parseInt(this.props.urlPageNumber) - 1};
    this.props.fetchCUGportfolioDataBySearch(body);
  }

  handleSearchChange = (event) => {
    if (event.key === PortfolioConstants.ENTER && event.target.value && event.target.value.length > 0 ) {
        this.props.preloading(true)
        event.preventDefault()
        console.log(event.target.value)
        this.setState({ searchKeyword : event.target.value, fetchSerach : true }, ()=>{
          this.fetchSerachData();
        })

        
        // TODO: @Navnath, add your magic here -----
        /* const searchRequest = SearchRequestBody(event.target.value, this.state.appliedFilters, this.state.toDate, this.state.fromDate)
        const requestBody = paginatedRequestBody(0, PortfolioConstants.PAGE_SIZE, this.state.sortField, this.state.sortType, searchRequest)
        this.props.searchPortfolio(requestBody);
        this.setState({
            searchText: event.target.value
        }) */

        setPageView('/Corporate/portfolio', event.target.value);

    }
  }

  render() {
    return (
      <div className="mt-2">
        <pre>
          <i className="icon-info mr-1"></i>CUG Portfolio displays the Rubix Credit Reports based on Trade Payment  data analysis of your portfolio companies.
        </pre>
        <Row className="d-flex justify-content-between no-gutters mb-3 position-relative">
          <Form className="form-search col-24 col-sm-8 mb-3 mb-sm-0">
              <FormGroup className="mb-0 input-search">
                  <i className="icon-search position-absolute search-icon-color" style={{ '--primaryColor': this.props.corporateColor.colorHexCode }}></i>
                  <Input className="bg-light" type="search" name="search" id="search" onKeyPress={this.handleSearchChange} placeholder="Search within CUG portfolio" autoComplete="off" />
              </FormGroup>
          </Form>
        </Row>

        <Row noGutters className="mb-3 custom-table-header d-none d-sm-flex align-items-center">
            <Col className="px-2">
                <Row noGutters className="align-items-center">
                    <Col className="custom-table-header-title px-2 py-3 " >Company Name </Col>
                    <Col className="custom-table-header-title px-2 py-3 " > Risk Score </Col>
                    <Col className="custom-table-header-title px-2 py-3 "> Risk Grade</Col>
                </Row>
            </Col>
        </Row>

        <CUGPortfolioTable corporateColor={this.props.corporateColor} />

        <div className="paginate-portfolio">
          {
            this.props.cugPortfoliioList 
            && this.props.cugPortfoliioList.totalPages > 1 
            && <ReactPaginate
                previousLabel={'Previous'}
                nextLabel={'Next'}
                breakLabel={'...'}
                breakClassName={pageLink}
                previousClassName={pageLink}
                nextClassName={pageLink}
                pageClassName={pageLink}
                activeClassName={currentLink}
                initialPage={this.state.currentPage}
                pageCount={this.props.cugPortfoliioList.totalPages}
                marginPagesDisplayed={2}
                pageRangeDisplayed={10}
                onPageChange={i => {
                    this.handleCugPortFolioPagination(i.selected)
                }}
                />
          }
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state) => ({ 
  cugPortfoliioList: state.cugPortfolio.cugPortfoliioList,
  corporateColor: state.corporate.corporateColor,
});

const mapDispatchToProps = dispatch => ({
  preloading: (isPreloading) => { dispatch(Preloading(isPreloading)); },
  fetchCUGPortfolioRequest: (data) => { dispatch(fetchCUGPortfolioRequest(data)) },
  saveCUGCorporateData : (data) => {dispatch(saveCUGCorporateData(data))},
  fetchCUGportfolioDataBySearch : (data) => {dispatch(fetchCUGportfolioDataBySearch(data))}
});

export default connect(mapStateToProps, mapDispatchToProps)(CUGPortfolio);